$(document).ready(function($) {
  console.log('OCR script loaded');
  const closeIco = `<svg xmlns="http://www.w3.org/2000/svg" width="11.644" height="11.317" viewBox="0 0 11.644 11.317">
  <path id="Combined-Shape" d="M16.762,7.4,7.238,16.6m0-9.2,9.523,9.2" transform="translate(-6.178 -6.341)" fill="none" stroke="red" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" fill-rule="evenodd"/>
</svg>`;
  const phoneImage = `<svg xmlns="http://www.w3.org/2000/svg" width="282.373" height="606.968" viewBox="0 0 282.373 606.968">
  <path id="Path_305" data-name="Path 305" d="M-534.039,25.421H-752.955a31.727,31.727,0,0,0-31.727,31.727V600.66a31.729,31.729,0,0,0,31.727,31.729h218.917a31.73,31.73,0,0,0,31.729-31.729V57.148A31.727,31.727,0,0,0-534.039,25.421ZM-507.52,592.9a17.754,17.754,0,0,1-8.536,15.182,17.672,17.672,0,0,1-9.224,2.578H-762.235a17.666,17.666,0,0,1-8.437-2.128A17.754,17.754,0,0,1-780,592.9V69.91a17.767,17.767,0,0,1,12.777-17.052,17.707,17.707,0,0,1,4.983-.711H-525.28a17.789,17.789,0,0,1,6.057,1.059,17.767,17.767,0,0,1,11.7,16.7Z" transform="translate(784.682 -25.421)" fill="#232323"/>
</svg>`;
  const inputFile = $('#input-file');
  const resultImage = $('#image-result figure img');
  const defaultImage = resultImage.attr('src');
  const fileNameInput = $('.input-name-ocr');
  const ocrStart = $('#ocr-start a');

  ocrStart.attr('disabled', true);
  $('<div class="loader hidden"></div>').insertBefore('#ocr-result');

  let file;
  inputFile.on('change', function() {
    file = null;
    file = this.files[0];
    if (file.type.includes('image') === true) {
      previewImage(file);
      ocrStart.attr('disabled', false);
      const fileName = file.name;
      fileNameInput.html(
        `<a id="reset-file" href="#" class="reset-form">${closeIco}</a>${fileName}`,
      );
      $('#reset-file').on('click', event => {
        event.preventDefault();
        inputFile.val(null);
        ocrStart.attr('disabled', true);
        $('#ocr-result').removeClass('show');
        resultImage.attr('src', defaultImage);
        fileNameInput.html('');
      });
    } else {
      alert(
        'Zły format pliku. Format pliku musi zawierać rozszerzenie jpeg, jpg lub png.',
      );
    }
  });

  ocrStart.on('click', event => {
    event.preventDefault();
    getResults(file);
  });

  const previewImage = file => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function() {
      resultImage.addClass('ocr-image');
      resultImage.attr('srcset', '');
      resultImage.attr('src', reader.result);
    };
    reader.onerror = function() {
      console.error(reader.error);
    };
  };

  const changeResults = response => {
    const valueDate =
      response.purchaseDate === null
        ? ' '
        : response.purchaseDate + ', ' + response.purchaseHour;
    $('#ocr-result').addClass('show');
    $('#ocr-result')
      .find('#shop')
      .text(response.shop.shortName);
    $('#ocr-result')
      .find('#nip')
      .text(response.taxID);
    $('#ocr-result')
      .find('#date')
      .text(valueDate);
    $('#ocr-result')
      .find('#cash-register-number')
      .text(response.tillNumber);
    $('#ocr-result')
      .find('#price')
      .text(response.price.toFixed(2) + ' zł');
    $('#ocr-result')
      .find('#reciept-number')
      .text(response.number);
  };

  const getResults = file => {
    let fd = new FormData();
    fd.append('file', file);
    fd.append('action', 'send_to_api');
    fd.append('_ajax_nonce', pp.nonce);
    $.ajax({
      url: pp.ajax_url,
      type: 'post',
      processData: false,
      contentType: false,
      resetForm: true,
      data: fd,
      beforeSend: function() {
        // setting a timeout
        $('.loader').removeClass('hidden');
      },
      success: function(response) {
        if(response.success === true) {
          changeResults(response.data.response)
        }
       ;
        inputFile.attr('disabled', true);
      },
      error: function() {
        // if error occured
        alert('Wystąpił błąd w połączeniu, spróbuj ponownie za jakiś czas');
        $('.loader').addClass('hidden');
      },
      complete: function() {
        $('.loader').addClass('hidden');
        inputFile.attr('disabled', false);
      },
    });
  };
});
